import { ArrowRightOutlined, ShoppingOutlined } from "@ant-design/icons";
import { Button, Card, Space, Typography } from "antd";
import { Link } from "react-router-dom";

import { ROUTES } from "@/constants";
import { useCart } from "@/hooks";

import { CartPriceSummary } from "./CartPriceSummary";

const { Text } = Typography;

export const CartSummary = () => {
  const { clearCart, finalTotal, itemCount, shippingFee, total } = useCart();

  return (
    <Card className="order-summary-card" title="Tóm tắt đơn hàng">
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <CartPriceSummary
          itemCount={itemCount}
          total={total}
          shippingFee={shippingFee}
          finalTotal={finalTotal}
        />
        <Link to={ROUTES.CHECKOUT}>
          <Button type="primary" icon={<ShoppingOutlined />} block>
            Đi đến thanh toán
          </Button>
        </Link>
        <Link to={ROUTES.PRODUCTS}>
          <Button icon={<ArrowRightOutlined />} block>
            Tiếp tục mua sắm
          </Button>
        </Link>
        <Button type="link" danger onClick={clearCart}>
          Xóa toàn bộ giỏ hàng
        </Button>
        <Text type="secondary">
          Giỏ hàng được giữ sau khi tải lại trang nhờ Redux Persist.
        </Text>
      </Space>
    </Card>
  );
};
